<app-configurations-form (createInterfaceConfiguration)="createInterfaceConfiguration($event)"
                         (createTrigger)="createTrigger($event)"
                   [deployment]="deployment$ | async"
                   [tenantName]="tenantName"
                   (testFields)="onTestFields($event)"
></app-configurations-form>
